import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { topValues } from "src/hooks/form";
import { HEADER_HEIGHT } from "src/styles/const";

// TOP画面のロジックを管理するカスタムフック
export const useTopPage = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<topValues>();

  // 画面遷移時直後のスクロール処理
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const tryScroll = () => {
        const el = document.querySelector(hash);
        if (el) {
          const y = el.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT;
          window.scrollTo({ top: y, behavior: "smooth" });
        } else {
          // 要素がまだ存在しない場合、再試行（最大5回）
          if (retryCount < 5) {
            setTimeout(tryScroll, 200);
            retryCount++;
          }
        }
      };

      let retryCount = 0;
      setTimeout(tryScroll, 300); // 初期遅延で読み込みを待つ
    }
  }, []);

  return {
    control,
    errors,
  };
};
